module.exports = __webpack_public_path__ + "img/food_taco.61006f5e.png";